module.exports = __webpack_public_path__ + "img/pro_four_7.87ca44a0.jpg";